import { render, staticRenderFns } from "./billing-documents-card.vue?vue&type=template&id=36ce6e69&scoped=true&lang=pug"
import script from "./billing-documents-card.vue?vue&type=script&lang=js"
export * from "./billing-documents-card.vue?vue&type=script&lang=js"
import style0 from "./billing-documents-card.vue?vue&type=style&index=0&id=36ce6e69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce6e69",
  null
  
)

export default component.exports